import React from "react";
import { useNavigate } from "react-router-dom";
import ProductForm from "./ProductForm";

const CreateProductForm = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black p-4 md:p-6">
      <ProductForm
        onCancel={() => navigate("/dashboard/products")}
        onSubmit={() => navigate("/dashboard/products")}
      />
    </div>
  );
};

export default CreateProductForm;
